module.exports = __webpack_public_path__ + "img/icon2.73e31a83.png";